export default __webpack_public_path__ + "static/media/pantry1-afterA-768w.0ff2a304.avif";